<template>
   <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          icon
          v-bind="attrs"
          v-on="on"
        >
        <v-icon v-if="useIcon">mdi-car-wrench</v-icon>
        <span v-else>Νεα Επισκεύη</span>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">Πληροφορίες Επισκεύης</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="repair">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="Κωδικός Οχήματος*"
                  :rules="[rules.required]"
                  v-model="VehId"
                  readonly
                  ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  label="Ένδειξη ταχογράφου*"
                  prepend-icon="mdi-counter"
                  suffix="χλμ."
                  v-model.number="Odometer"
                  type="tel"
                  ></v-text-field>
              </v-col>
            <v-col cols="6" sm="4">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateText"
                  label="Ημερομηνία"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="RepairDate"
                @input="menu = false"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
              <v-col
                cols="12"
              >
                <v-textarea
                  prepend-icon="mdi-notebook"
                  rows="2"
                  :auto-grow=true
                  label="Σημειώσεις"
                  v-model="Notes"
                  hint="Προαιρετικά"
                  ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <small>*indicates required field</small>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Κλείσιμο
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="saveRepair"
          >
            Αποθήκευση
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>

  export default {

   computed: {
      dateText () {
        return new Date(this.RepairDate).toISOString().substr(0,10);
      },
    },
    props: {
        VehId: { required: true },
        useIcon: { default: false },
    },
    data() {
      return {
        RepairDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        Odometer: 0,
        Notes: '',
        menu: false,
        dialog: false,
        saveDisable: false,
        rules: {
          required: value => !!value || 'Required.',
        },
     }
    },
    async mounted() {

    },

    methods: {
    async saveRepair () {
      console.log(this.newRepair);
      if (this.$refs.repair.validate()) {
        var newRepair = {
          "VehId": this.VehId,
        "Date": this.RepairDate,
        "Odometer": this.Odometer,
        "Notes": this.Notes,
        }
        const resp = await this.$api.post("/repairs/", newRepair);
        if (resp.status == 201) {
          console.log(resp);
        } else
        {
          alert(resp.data.detail);
        }

        this.dialog = false;
      }
    },
    },
  }

</script>
